// Utils
import platformSingleton from '../platform/platformSingleton';
import { isPlatformElectronMac } from '../platform/utils/platformDetailsUtils';

let configureStore;

if (isPlatformElectronMac(platformSingleton)) {
    configureStore = require('./configureStoreElectronClient').default;
} else {
    configureStore = require('./configureStoreWeb').default;
}

export default configureStore;
